import { AdvanceAmountDto, RecommendedAmountResponseError } from '@eneco/dc-be/client';
import { isAfter, isToday } from 'date-fns';

const HIDE_EDIT_RECOMMENDED_AMOUNT_ERRORS: RecommendedAmountResponseError[] = [
  'InvoiceOrEndnoteNeedsToBeCreatedFirst',
  'NoContractorFoundForConnection',
  'LastAdvanceDatetimeEqualToBillingDate',
];

const hasActiveVacancy = (advancePayments: Array<AdvanceAmountDto | undefined> | null | undefined) => {
  const payments = advancePayments?.filter((advance): advance is AdvanceAmountDto => advance != null);
  if (!payments || payments.length === 0) return false;

  return payments.some(payment => {
    const details = payment.details;
    if (details?.vacancyChangeRequested) return true;

    const vacancyUntil = new Date(details?.vacancyUntil ?? '');
    return isAfter(vacancyUntil, new Date()) || isToday(vacancyUntil);
  });
};

export const canEditAdvanceAmount = ({
  isCurrentAccountReader,
  advancePayments,
}: {
  isCurrentAccountReader: boolean;
  advancePayments: Array<AdvanceAmountDto | undefined> | null | undefined;
}) => {
  const payments = advancePayments?.filter((a): a is AdvanceAmountDto => a != null);
  if (!payments || payments.length === 0) return false;

  const isYearlyInvoiced = payments.some(advance => advance.meterDetails?.invoiceFrequency === 'Yearly');
  const isDefaulter = payments.some(advance => advance.details?.isDefaulter ?? false);
  const isAvailable = payments.every(advance => !advance.details?.notAvailable);
  const isVacancyActive = hasActiveVacancy(payments);
  const hasBlockingRecommendedAmountError = payments.some(
    advance =>
      advance.details?.recommendedAmountError != null &&
      HIDE_EDIT_RECOMMENDED_AMOUNT_ERRORS.includes(advance.details.recommendedAmountError),
  );

  if (isCurrentAccountReader) return false;
  if (isDefaulter) return false;
  if (isVacancyActive) return false;
  if (hasBlockingRecommendedAmountError) return false;
  if (!isYearlyInvoiced) return false;
  if (!isAvailable) return false;
  return true;
};
